import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import {
  CardSection,
  CardTitle,
} from '../../ArticlePage/RelatedArticlesNew/styled';
import { QNATopicList, TopicsEachSection } from './styled';
import { randomTopicColor } from '../../../Constants/QuestionPage';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function RelatedTopics(props) {
  const { topics, pageType, paddingBottom } = props;
  const [cardEffect, setCardEffect] = useState({ index: null, effect: '' });

  function getUniqueTopic() {
    return [
      ...new Map(
        topics?.map((element) => [
          element['description'] || element['title'],
          element,
        ]),
      ).values(),
    ];
  }

  const uniqueTopic = getUniqueTopic();

  useEffect(() => {
    if (uniqueTopic?.length > 0) {
      let cardId = [];
      uniqueTopic.forEach((element) => {
        cardId.push(element.term_id || element?.id);
      });
      fireServedSectionEvent('related Topic', cardId, pageType);
    }
  }, [uniqueTopic]);
  const router = useRouter();

  return (
    <>
      {uniqueTopic.length > 0 ? (
        <CardSection marginBottom={'9rem'}>
          <CardTitle as="h2">Related Topics</CardTitle>
          <QNATopicList>
            {uniqueTopic?.map((element, index) => {
              const web_url = element?.webUrl || element?.web_url;
              return (
                <AnchorCoverTag
                  url={web_url}
                  key={`related_topic${index}`}
                  cardEffect={
                    index === cardEffect.index ? cardEffect.effect : ''
                  }
                >
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setCardEffect({
                        index: index,
                        effect: 'lowOpacity',
                      });
                      setTimeout(() => {
                        router.push(web_url + getSearchParams(), '', {
                          locale: getRouterLocale(router),
                        });
                      }, [200]);
                    }}
                  >
                    <TopicsEachSection bg={randomTopicColor[index]} as="h3">
                      {element.description || element.title}
                    </TopicsEachSection>
                  </a>
                </AnchorCoverTag>
              );
            })}
          </QNATopicList>
        </CardSection>
      ) : null}
    </>
  );
}
